// ink-component
import React, { ReactNode, useContext } from 'react';
import { SideNavContext } from '../../SideNavContext';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { StyledSideNavStickyContainer } from './styles';

export type SideNavStickyContainerProps = {
  /** Position of the sticky container */
  position: 'top' | 'bottom';
  /** Content alignment of the sticky container */
  justify?: 'space-between' | 'flex-end';
  /** @ignore */
  hideFilter?: boolean;
  /** Child content */
  children: ReactNode;
  /** Marks the element with a given ID to make it easier to select it on tests */
  'data-testid'?: string | number;
};

/**
 * @purpose Sticky content container to wrap the inner content of the SideNav
 * @group SideNav
 * @categories navigation
 */
const SideNavStickyContainer = (props: SideNavStickyContainerProps) => {
  const { isClosed, isScrolling } = useContext(SideNavContext);
  const globalProps = getGlobalProps({});
  return <StyledSideNavStickyContainer {...props} {...globalProps} isClosed={isClosed} isScrolling={isScrolling} />;
};

SideNavStickyContainer.displayName = 'SideNav.StickyContainer';

export default SideNavStickyContainer;
